/**
 * 每一轮重画之后的叠瓦读数，摊成一条。
 *
 * 背景：结构化的纹理只能靠重画来降，而一趟最多重画两轮（服务端把 max_regen 掐在 2）。
 *   撞上限停下来时，这一屏此前只有一个数字——处理前那个。2026-09-13 用户实撞：
 *   一张 36.4% 的图重画两轮之后实测已经降到 11.4%，屏上却仍写着 36.4%，
 *   他问的是「这是搞不定吗」。屏上少的不是解释，是中间那两个数。
 * 设计意图：把每一轮的读数按顺序摆出来，让「还差一轮」与「压不动」长得不一样。
 *   一句趋势话跟在后面（roundsTrend），它是「再来一轮」值不值的唯一依据。
 * 关键约束：
 *   1. 一个数都不在这里算。读数由服务端从每一轮的诊断里压出来（round_reading），
 *      判定线也跟着诊断走（管线的 structured_min_pct），页面不写死 6%。
 *   2. 不预测下一轮。出图有随机性，管线自己也只是一轮一轮量。
 */
import type { RoundReading } from '../types'
import { roundLabel, roundsTrend } from '../copy/explain'

export function RoundCurve({ rounds, note }: {
  rounds: RoundReading[]
  /** 录像那一卷要交代这条曲线的出处（见 mock/runs.ts 的 STALLED_ROUNDS）。 */
  note?: string
}) {
  const pts = rounds
    .filter(r => typeof r.scale_pct === 'number')
    .sort((a, b) => a.round - b.round)
  if (pts.length < 2) return null
  const line = pts.find(r => typeof r.scale_line === 'number')?.scale_line
  const trend = roundsTrend(pts)
  return (
    <div className="rounds">
      <p className="rounds-head">
        叠瓦指数一轮一轮的变化
        {line != null && <span>（{line}% 以下才算修好）</span>}
      </p>
      <ol className="rounds-list">
        {pts.map(r => (
          <li key={r.round} className={r.round === pts[pts.length - 1].round ? 'is-last' : undefined}>
            <b>{r.scale_pct}%</b>
            <span>{roundLabel(r.round)}</span>
          </li>
        ))}
      </ol>
      {trend && <p className="rounds-trend">{trend}</p>}
      {note && <p className="rounds-note">{note}</p>}
    </div>
  )
}
